export default {
  buttons: {
    apply: "Pielietot",
    cancel: "ATCELT",
    dismiss: "Aizvērt",
    minimize: "samazināt",
    unminimize: "palielināt",
    add_waypoint: "pievienot galapunktu"
  },
  distance: {
    value: "{distance, number, distance} {unit}",
    unit: {
      miles: "jūdze"
    }
  },
  search: {
    title: "Meklēt",
    placeholder: "Ievadiet vietu",
    enter_location: "Ievadiet vietu",
    recent_searches: "Pēdējie meklēšanas rezultāti",
    suggestions: "Ieteikumi",
    geolocation: "Izmantot manu atrašanās vietu",
    help: {
      inactive: "Meklēt",
      clear: "Notīrīt"
    }
  },
  filters: {
    title: "Filtri",
    more: "Vairāk filtru",
    less: "Mazāk filtru",
    group: {
      more: "Vairāk",
      less: "Mazāk"
    },
    amenities: {
      title: "Pakalpojumi un ērtības"
    },
    fuels: {
      title: "Degvielas veidi"
    }
  },
  directions: {
    title: "Maršruta plānotājs",
    help: {
      add_waypoint: "Pievienot ceļa punktu",
      reverse: "Mainit virzienu",
      sort_waypoint: "Pārvelciet, lai pārkārtotu",
      remove: "Noņemt ceļas punktu"
    },
    placeholder: {
      origin: "Izvelaties sākuma punktu",
      destination: "Ievadiet vietu",
      waypoint: "Ievadiet vietu"
    },
    route: {
      title: "Maršruta opcijas",
      title_avoid: "Izvairīties",
      avoid_tolls: "Izvairieties no maksas ceļiem",
      avoid_highways: "Izvairieties no maksas automaģistrālēm",
      avoid_ferries: "Izvairoties no prāmjiem",
      title_corridor: "Attālums no maršruta līdz degvielas uzpildes stacijām"
    },
    travel_time: `\
{weeks, plural, =0 {} =1 {# nedēļa} other {# nedēļas}}
{days, plural, =0 {} =1 {# diena} other {# dienas}}
{hours, plural, =0 {} =1 {# st} other {# st}}
{minutes, plural, =0 {} =1 {# min} other {# min}}\
`,
    button: "Meklēt",
    error: "Radās problēma ar maršruta plānošanu, lūdzu, mēģiniet vēlreiz"
  },
  action_panel: {
    back_to_results: "Atpakaļ pie meklēšanas"
  },
  locations: {
    title: "lokācijas",
    closed_temporarily: "Slēgts uz laiku",
    distance: "{distance, number, distance} {unit}",
    distance_from: "{distance, number, distance} {unit} no {place}",
    description: "{visible, select, true {Slēpt} false {Parādīt} }"
  },
  info_window: {
    back_to_results: "Atpakaļ pie meklēšanas",
    title: "Stacijas detaļas",
    location_id: "Stacijas ID",
    website: "Mājaslapa",
    services: "Pakalpojumi un ērtības",
    nearby: "Tuvumā",
    directions: "Pievienot maršruta plānotājam",
    mobile: {
      telephone: "Tālrunis:"
    },
    opening_hours: {
      title: "Atvēršanas un slēgšanas stundas",
      mon: "P.",
      tue: "O.",
      wed: "T.",
      thu: "C.",
      fri: "Pk.",
      sat: "S.",
      sun: "Sv.",
      open_twentyfourhours: "24 stundas",
      period: "{start, time, short} – {end, time, short}"
    },
    fuel_prices: {
      available: "Pieejamās cenas degvielai",
      not_available: "Pieejama degviela",
      price: "{price, number, fuelPrice}",
      disclaimer: "Visa informācija ir sagatavota bez garantijas: dgvielas cenas uz pilona ir korektas",
      last_updated_on: "Pēdējais atjaunojums",
      timestamp: "{timestamp, date, dateFormat}"
    }
  },
  itinerary: {
    title: "Maršruta plānotājs"
  },
  fuels: {
    autogas_lpg: "Аutogāze (LPG)",
    midgrade_gasoline: "Shell 95",
    premium_diesel: "Shell V-Power dīzeļdegviela",
    premium_gasoline: "Shell V-Power",
    shell_regular_diesel: "Shell dīzeļdegviela",
    super_premium_gasoline: "Shell V-Power Racing",
    unleaded_super: "Shell 95"
  },
  amenities: {
    air_and_water: "Gaiss",
    atm_in: "Naudas iemaksas bankomāts",
    atm_out: "Naudas izmaksas bankomāts",
    atm: "Bankomāts",
    austrian_highway_sticker: "Austrijas vinjetes",
    bakery_shop: "Maiznīca",
    bank_note_acceptor: "Bankomāts",
    bottled_gas: "BBQ gāzes balona apmaiņa (propāns)",
    carwash: "Mazgātuve",
    childs_toilet: "Tualetes vai bērnu tualetes",
    clubsmart_card: "Shell ClubSmart karte",
    credit_card_american_express: "Kredītkarte - American Express",
    credit_card_diners_club: "Kredītkarte - Dinners Club",
    credit_card_general: "Kredītkarte",
    credit_card_mastercard: "Kredītkarte - Mastercard",
    credit_card_visa: "Kredītkarte - Visa",
    credit_card: "Kredītkarte",
    czech_highway_sticker: "Čehu vinjetes",
    disability_assistance: "Palīdzība invalīdiem",
    disabled_facilities: "Invalīdu ērtības",
    euroshell_card: "euroShell / Shell Card",
    fleet_card_eni: "Korporatīvā karte - Eni",
    fleet_card_esso: "Korporatīvā karte - Esso",
    fleet_card_general: "Korporatīvā karte",
    fleet_card_uta: "Korporatīvā karte - UTA",
    food_offerings: "Ēdienu piedāvajums",
    fuel_card: "Degvielas karte",
    full_service: "Apkalpojošais personāls",
    guarded_car_park: "Apsargāta autostāvvieta",
    hgv_lane: "Kravas mašīnu draudzīga",
    high_speed_diesel_pump: "Ātra dīzeļa padeve",
    hot_food: "Karstie ēdieni",
    hungarian_highway_sticker: "Ungārijas vinjetes",
    loyalty_cards: "Lojalitātes kartes",
    mobile_payment: "Mobilā apmaksa",
    motorway_service: "Šosejas serviss",
    parking_lanes: "Autostāvvieta",
    partner_loyalty_accepted: "Pieņemta partneru lojalitēte",
    pay_at_pump: "Apmaksa uz sūkņa",
    quick_lubes: "Strauja eļļošana",
    restaurant: "Restorāns",
    self_service: "Pašapkalpošanās",
    service_bay: "Apkalpošana sala",
    shell_card: "euroShell / Shell Card",
    shell_club_smart_extra_card: "Shell ClubSmart Extra karte",
    shop: "Veikals",
    shower: "Duša",
    slovak_highway_sticker: "Slovāku vinjetes",
    snack_food: "Uzkodas / Fast food",
    standard_toilet: "Tualete",
    supermarket_fuel_discount: "Degvielas Atlaide",
    toilet: "Tualete",
    truck_parking: "Kravas automašīnas stāvvieta",
    truckport: "Tikai kravas mašīnas",
    twenty_four_hour: "24 stundas",
    unmanned: "Bez personāla",
    vacuum: "Putekļsūcējs",
    vehicle_identity_system: "Mašīna atpazīšanas sistēma"
  },
  settings: {
    title: "Iestatījumi",
    tooltip: "Iestatījumi",
    traffic: "Satiksme",
    distance_units: {
      km: "kilometri",
      miles: "jūdze"
    },
    language: {
      title: "Valoda",
      locales: {
        es_AR: "Argentīna spāņu",
        en_AU: "Austrija angļu",
        de_AT: "Austrija vācu",
        fr_BE: "Beļģija franču",
        nl_BE: "Beļģija holandiešu",
        pt_BR: "Brazīlijas portugāļu",
        en_BG: "Bulgārija angļu",
        bg_BG: "Bulgārija bulgāru",
        fr_CA: "Kanāda franču",
        en_CA: "Kanāda angļu",
        cz_CZ: "Čehija čehu",
        da_DK: "Dānija dāņu",
        fi_FI: "Somija Somijas",
        fr_FR: "Francija franču",
        de_DE: "Vācija vācu",
        en_HK: "Honkonga English",
        zh_HK: "Honkonga Ķīniešu (tradicionālā)",
        hu_HU: "Ungārija ungāru",
        en_IN: "Indija angļu",
        en_ID: "Indonēzija angļu",
        id_ID: "Indonēzija indonēzijas",
        it_IT: "Itālija itaļu",
        lv_LV: "Latvija latviešu",
        lt_LT: "Lietuva lietuviešu",
        fr_LU: "Luksemburga franču",
        en_LU: "Luksemburga angļu",
        en_MY: "Malaizija angļu",
        en_MO: "Makao English",
        zh_MO: "Makao Ķīniešu (tradicionālā)",
        nl_NL: "Nīderlande holandiešu",
        nb_NO: "Norvēgija norvēģu (Būkmols)",
        en_OM: "Omāna angļu",
        ar_OM: "Omāna arābu",
        en_PK: "Pakistāna angļu",
        ur_PK: "Pakistāna urdu",
        en_PH: "Filipīnas angļu",
        pl_PL: "Polija poļu",
        es_PR: "Puertoriko spāņu",
        ro_RO: "Rumānija rumānijas",
        ru_RU: "Krievija krievu",
        en_SG: "Singapore angļu",
        sk_SK: "Slovākija slovākijas",
        sl_SI: "Slovēnija slovēnijas",
        en_ZA: "Dienvidāfrika angļu",
        sv_SE: "Zviedrija zviedru",
        fr_CH: "Šveice franču",
        de_CH: "Šveice vācu",
        th_TH: "Taizeme taizemes",
        tr_TR: "Turcija turku",
        uk_UA: "Ukraina ukrainas",
        en_GB: "Apvienotā Karaliste angļu",
        en_US: "ASV angļu"
      }
    }
  },
  geolocation: {
    tooltip: "Izmantot manu atrašanās vietu"
  }
}
